import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPremiumBackground = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 332,
	height: 168,
	viewBox: "0 0 332 168",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_f_1869_12867)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M4 12C4 7.58172 7.58172 4 12 4H320C324.418 4 328 7.58172 328 12V156C328 160.418 324.418 164 320 164H12C7.58172 164 4 160.418 4 156V12Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4 12C4 7.58172 7.58172 4 12 4H320C324.418 4 328 7.58172 328 12V156C328 160.418 324.418 164 320 164H12C7.58172 164 4 160.418 4 156V12Z",
					fill: "url(#paint0_linear_1869_12867)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4 12C4 7.58172 7.58172 4 12 4H320C324.418 4 328 7.58172 328 12V156C328 160.418 324.418 164 320 164H12C7.58172 164 4 160.418 4 156V12Z",
					fill: "white",
					fillOpacity: .1
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4 12C4 7.58172 7.58172 4 12 4H320C324.418 4 328 7.58172 328 12V156C328 160.418 324.418 164 320 164H12C7.58172 164 4 160.418 4 156V12Z",
					fill: "url(#paint1_radial_1869_12867)",
					fillOpacity: .7
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_1869_12867",
				x: 0,
				y: 0,
				width: 332,
				height: 168,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 2,
						result: "effect1_foregroundBlur_1869_12867"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_1869_12867",
				x1: 4,
				y1: 84,
				x2: 328,
				y2: 84,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#2355EE" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#0E1A35"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_1869_12867",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(166 4) rotate(44.6441) scale(227.693 81.2878)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#8431FF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#8431FF",
					stopOpacity: 0
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgPremiumBackground);
export default ForwardRef;
